<template>
	<nav class="navbar navbar-expand-lg">
		<span class="navbar-brand">
			<a href="/"><img src="@/assets/images/lobo_white.png"></a>
			<div>Receipt and Letter Generator</div>
		</span>
	  	<button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
			<span class="navbar-toggler-icon"></span>
	  	</button>
	  	<div class="collapse navbar-collapse" id="navbarNavAltMarkup">
			<ul class="navbar-nav">
				<li><router-link tag="a" class="nav-item nav-link" :to="{name: 'ereceipt', params: {}}"><i class="fas fa-envelope"></i> e-Receipts</router-link></li>
				<li><router-link tag="a" class="nav-item nav-link" :to="{name: 'date', params: {}}"><i class="fas fa-calendar-day"></i> By Date</router-link></li>
 				<li><router-link tag="a" class="nav-item nav-link" :to="{name: 'receipt', params: {}}"><i class="fas fa-file-invoice-dollar"></i> By Receipt</router-link></li>
				<li><router-link tag="a" class="nav-item nav-link" :to="{name: 'donor', params: {}}"><i class="fas fa-user"></i> By Donor ID</router-link></li>				
			</ul>
	  	</div>
		<span class="navbar-text">			
			<span v-if="user.ID"><i class="fas fa-user"></i> You are logged in as {{user.FIRSTNAME}} {{user.LASTNAME}}</span>			
		</span>			
	</nav>
</template>

<script>
export default {
	props: ['user']
}
</script>
<style scoped>
.navbar-nav {

}
.navbar .navbar-brand a img {
	width: 150px;
	padding-bottom: 5px;
}
.navbar .navbar-brand a {
	text-decoration: none;
}
.navbar .navbar-brand {
	line-height: 1.0em;
	font-size: 18px;
	color: #FFF;
	font-family: 'Roboto';
}

.navbar .navbar-brand a {
	font-size: 24px;	
	color: #FFF;
	text-transform: uppercase;
}

.navbar .navbar-brand a:hover {
	text-decoration: none;
}

.navbar .navbar-brand a span.bold {
	font-family: Roboto;	
	font-weight: bold;
}

.navbar.navbar-expand-lg {
    background-color: #C00;
	padding: 0 1rem;
}

.navbar .navbar-text {
    color: #FFF;
	padding: 0;
}

.navbar .navbar-nav>li>a {
    color: #FFF;
}

.navbar .navbar-nav li a.nav-item.router-link-active, 
.navbar .navbar-nav li a.nav-item.router-link-active:focus, 
.navbar .navbar-nav li a.nav-item.router-link-active:hover {
    color: #C00;
    background-color: #FFF;
}

.navbar .navbar-nav>li>a:hover {
    color: #333;
    background-color: #f2dede;
}

.navbar .navbar-text {
	margin-top: 8px;
	margin-bottom: 8px;
}

.navbar-expand-lg .navbar-nav .nav-link {
	padding: 1.3rem !important;
	font-size: 1.2rem;
	margin-top: 10px;
}

</style>